import { useContext } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import { Group, Skeleton, Stack, Title, Text } from '@mantine/core'
import { StationSelect } from '@/components/stations/station-select/station-select'
import { StationContext } from '@/pages/station-context'

export const StationHeader = () => {
  const { station, isLoading } = useContext(StationContext)
  const { speciId, offerId } = useParams()

  // On pages where we are interacting with a specific wool specification or offer object,
  // we don't want to show the station selector as it would be confusing to the user.
  const showSelector = !speciId && !offerId

  return (
    <Stack>
      <Group justify='space-between' align-items='center' preventGrowOverflow>
        {isLoading ? (
          <>
            <Skeleton visible height={45} width='60%' />
            <Skeleton visible height={45} width='30%' />
          </>
        ) : (
          <>
            <Title order={1}>
              {station.brand}{' '}
              <Text component='span' c='gray.5' inherit>
                {station.recordNumber}
              </Text>
            </Title>
            {showSelector && <StationSelect />}
          </>
        )}
      </Group>
      {isLoading ? <Skeleton visible height={400} /> : <Outlet />}
    </Stack>
  )
}
